import { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom'; 
import { StorageKeys } from "../../../services/constants/StorageKeys";
import { storage } from "../../../services/storageService";
import Page from "../../../components/Page";
import { Routes } from "../../../routes/RouteConstants";
import Article from "../../../components/Article";
import Loading from "../../../components/Loading";

const SuccessfulLoginLayout = () => {
  const navigate = useNavigate();
  const { forceHeaderReRender } = useOutletContext();

  useEffect(() => {
    storage.set(StorageKeys.IS_USER_AUTHENTICATED, true);
    // A guest who gave up on the code and signed in with Google has no request left to finish.
    storage.remove(StorageKeys.EMAIL_VERIFICATION);

    const targetRouteBeforLogin = storage.get(StorageKeys.TARGET_ROUTE_BEFORE_REDIRECT);
    storage.remove(StorageKeys.TARGET_ROUTE_BEFORE_REDIRECT);
  
    // Replace: a way station in the history would send Back straight on to the target again.
    if (targetRouteBeforLogin) {
      navigate(targetRouteBeforLogin, { replace: true });
    } else {
      navigate(Routes.PROFILE, { replace: true });
    }

    forceHeaderReRender();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <Article title="Sikeres hitelesítés">
        <Loading />
      </Article>
    </Page>
  );
};

export default SuccessfulLoginLayout;
